// LanguageSwitcher.js
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import axiosInstance from 'utils/axiosInstance';

import './LanguageSwitcher.css';

// A list of languages you want to display in the dropdown
const languages = [
  { value: 'en', label: 'English' },
  { value: 'zh', label: '繁體中文' },
  { value: 'jp', label: '日本語' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const handleLanguageChange = async (newLang) => {
    console.log('Switching language to:', newLang);
    i18n.changeLanguage(newLang);

    try {
      // If user is logged in, update their language preference on your backend
      await axiosInstance.patch('/knovia/user/language', { language: newLang });
    } catch (error) {
      console.error('Error updating user language:', error);
    }
  };

  // Optional: watch the language change
  useEffect(() => {
    console.log('i18n.language:', i18n.language);
  }, [i18n.language]);

  // Find the label for the currently active language
  const currentLanguageLabel =
    languages.find((lang) => lang.value === i18n.language)?.label || 'English';
  

  return (
    <UncontrolledDropdown className="my-language-dropdown">
      <DropdownToggle color="primary" caret>
        {currentLanguageLabel}
      </DropdownToggle>
      <DropdownMenu>
        {languages.map((lang) => (
          <DropdownItem
            key={lang.value}
            onClick={() => handleLanguageChange(lang.value)}
          >
            {lang.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );

}




